import { CompressionService } from '@/interfaces/services/compression';
import { FileDownloadService } from '@/interfaces/services/download';
import { FileUploadService } from '@/interfaces/services/upload';
import { ImageCompressionService } from '@/services/compression';
import { HttpFileDownloadService } from '@/services/download';
import { useLoggingService } from '@/services/logging/composable';
import { HttpFileUploadService } from '@/services/upload';

import { ContainerModule, IoCContainer } from '../framework/container';

export class ServiceModule implements ContainerModule {
  public onCreate(container: IoCContainer): void {
    container.register<CompressionService>('CompressionService', () => {
      return new ImageCompressionService();
    });

    container.register<FileDownloadService>(
      'FileDownloadService',
      () => new HttpFileDownloadService(useLoggingService()),
    );

    container.register<FileUploadService>('FileUploadService', () => {
      return new HttpFileUploadService();
    });
  }
}
